import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { CartProvider } from "@/lib/cart";
import { ShopProvider } from "@/lib/shop";
import { setLenis, scrollTop, scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/site/Nav";
import { Signup } from "@/components/site/Signup";
import { Footer } from "@/components/site/Footer";
import { CartDrawer } from "@/components/site/CartDrawer";
import { MobileBar } from "@/components/site/MobileBar";
import { MysteryGame } from "@/components/site/game/MysteryGame";
import HomePage from "@/pages/HomePage";
import { ShopPage, StoryPage, ReviewsPage, NutritionPage, FaqPage, StoresPage } from "@/pages/Pages";
import BuildBoxPage from "@/pages/BuildBoxPage";
import FlavourPage from "@/pages/FlavourPage";
import { ShopifyAnalytics } from "@/components/site/ShopifyAnalytics";
import { LegacyAccount, LegacyPage, LegacyProduct, LegacyShop } from "@/components/site/LegacyRedirects";
import GiftPage from "@/pages/GiftPage";
import StatsPage from "@/pages/StatsPage";
import { VisitTracker } from "@/lib/track";

const ScrollReset = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    scrollTop();
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

const Site = () => (
  <div className="grain min-h-screen overflow-x-clip bg-[#FFF6EA] text-[#1B1530]">
    <Nav />
    <main>
      <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/flavours/:key" element={<FlavourPage />} />
                <Route path="/build" element={<BuildBoxPage />} />
                <Route path="/gift/:token" element={<GiftPage />} />
                <Route path="/story" element={<StoryPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/nutrition" element={<NutritionPage />} />
                <Route path="/stores" element={<StoresPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/products/:handle" element={<LegacyProduct />} />
                <Route path="/collections/:c/products/:handle" element={<LegacyProduct />} />
                <Route path="/collections/*" element={<LegacyShop />} />
                <Route path="/cart" element={<LegacyShop />} />
                <Route path="/pages/:page" element={<LegacyPage />} />
                <Route path="/account/*" element={<LegacyAccount />} />
                <Route path="/account" element={<LegacyAccount />} />
                <Route path="*" element={<HomePage />} />
              </Routes>
            </main>
            <Signup />
            <Footer />
            <CartDrawer />
            <MobileBar />
            <MysteryGame />
            <Toaster position="top-center" richColors />
          </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    setLenis(lenis);
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); setLenis(null); };
  }, []);

  return (
    <BrowserRouter>
      <ShopProvider>
        <CartProvider>
          <ScrollReset />
          <ShopifyAnalytics />
          <VisitTracker />
          <Routes>
            <Route path="/stats" element={<StatsPage />} />
            <Route path="*" element={<Site />} />
          </Routes>
        </CartProvider>
      </ShopProvider>
    </BrowserRouter>
  );
}

export default App;
